"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _VoucherUtil = require("../../utils/VoucherUtil");

var util = _interopRequireWildcard(_VoucherUtil);

var _VoucherTypeSwitch = require("./VoucherTypeSwitch");

var _VoucherTypeSwitch2 = _interopRequireDefault(_VoucherTypeSwitch);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserPickupVouchersPanel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(UserPickupVouchersPanel, _Component);

  function UserPickupVouchersPanel() {
    (0, _classCallCheck3.default)(this, UserPickupVouchersPanel);
    return (0, _possibleConstructorReturn3.default)(this, (UserPickupVouchersPanel.__proto__ || (0, _getPrototypeOf2.default)(UserPickupVouchersPanel)).apply(this, arguments));
  }

  (0, _createClass3.default)(UserPickupVouchersPanel, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(
          "div",
          { className: "col col-xs-12" },
          _react2.default.createElement(_VoucherTypeSwitch2.default, this.props),
          _react2.default.createElement(
            "h1",
            { className: "h2" },
            "Ostetut noutolipukkeet"
          ),
          _react2.default.createElement(
            "div",
            { className: "user-vouchers" },
            _react2.default.createElement(
              "table",
              { className: "table user-vouchers-table" },
              _react2.default.createElement(
                "thead",
                null,
                _react2.default.createElement(
                  "tr",
                  null,
                  _react2.default.createElement(
                    "th",
                    null,
                    "Tilausnro:"
                  ),
                  _react2.default.createElement(
                    "th",
                    { className: "hidden-mobile" },
                    "Nro:"
                  ),
                  _react2.default.createElement(
                    "th",
                    null,
                    "Noutopaikka:"
                  ),
                  _react2.default.createElement(
                    "th",
                    null,
                    "Kpl:"
                  ),
                  _react2.default.createElement(
                    "th",
                    { className: "hidden-mobile" },
                    "Hinta/lipuke:"
                  ),
                  _react2.default.createElement(
                    "th",
                    { className: "hidden-mobile" },
                    "Alv:"
                  ),
                  _react2.default.createElement(
                    "th",
                    { className: "hidden-mobile" },
                    "Hinta yht.:"
                  )
                )
              ),
              _react2.default.createElement(
                "tbody",
                null,
                this.renderVouchers()
              )
            )
          )
        )
      );
    }
  }, {
    key: "renderVouchers",
    value: function renderVouchers() {
      var _this2 = this;

      return this.props.vouchers.map(function (voucher, index) {
        return _react2.default.createElement(
          "tr",
          { key: index, className: "voucher-row-js" },
          _react2.default.createElement(
            "td",
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: _this2.getPath(voucher) },
              voucher.order_id
            )
          ),
          _react2.default.createElement(
            "td",
            { className: "hidden-mobile" },
            util.getNumbers(voucher)
          ),
          _react2.default.createElement(
            "td",
            null,
            voucher.name
          ),
          _react2.default.createElement(
            "td",
            null,
            voucher.quantity - voucher.quantity_printed,
            "/",
            voucher.quantity
          ),
          _react2.default.createElement(
            "td",
            { className: "hidden-mobile" },
            util.priceWithVAT(voucher)
          ),
          _react2.default.createElement(
            "td",
            { className: "hidden-mobile" },
            "25.5%"
          ),
          _react2.default.createElement(
            "td",
            { className: "hidden-mobile" },
            util.totalPriceWithVAT(voucher)
          )
        );
      });
    }
  }, {
    key: "getPath",
    value: function getPath(voucher) {
      var params = this.props.params;

      if (params.token) {
        return "/noutolipukkeet/" + params.token + "/" + voucher.id;
      }
      return "/ostetut-noutolipukkeet/" + voucher.order_id + "/" + voucher.id;
    }
  }]);
  return UserPickupVouchersPanel;
}(_react.Component), _class.propTypes = {
  vouchers: _react.PropTypes.array.isRequired,
  params: _react.PropTypes.object.isRequired,
  pathname: _react.PropTypes.string.isRequired
}, _temp);
exports.default = UserPickupVouchersPanel;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/uservouchers/UserPickupVouchersPanel.js
 ** module id = 1194
 ** module chunks = 0
 **/